import React, { useState } from 'react';
import { FaBox, FaShoppingCart, FaClipboardCheck, FaTruck } from 'react-icons/fa';

// Componentes locales
import RepuestosExternosInventario from './RepuestosExternosInventario';
import CarritoRepuestosExternos from './CarritoRepuestosExternos';
import PagoRepuestosExternos from '../pagos/PagoRepuestosExternos';
import SeguimientoOrdenesExternas from '../ordenes/SeguimientoOrdenesExternas';
import { Tabs, Tab } from '@/components/common/Tabs';
import Badge from '@/components/common/Badge';

// Datos mock para el carrito
const mockCarrito = [];

const RepuestosExternosPage = () => {
  const [carrito, setCarrito] = useState([]);
  const [activeTab, setActiveTab] = useState('inventario');
  const [showCarrito, setShowCarrito] = useState(false);
  const [showPago, setShowPago] = useState(false);
  
  // Función para agregar un repuesto al carrito
  const agregarAlCarrito = (repuesto) => {
    setCarrito(prevCarrito => {
      const existe = prevCarrito.find(item => 
        item.id === repuesto.id && item.esExterno === repuesto.esExterno
      );
      
      if (existe) {
        return prevCarrito.map(item =>
          item.id === repuesto.id && item.esExterno === repuesto.esExterno
            ? { ...item, cantidad: item.cantidad + 1 }
            : item
        );
      }
      
      return [...prevCarrito, { ...repuesto, cantidad: 1 }];
    });
  };
  
  // Función para eliminar un repuesto del carrito
  const eliminarDelCarrito = (repuestoId, esExterno) => {
    setCarrito(prevCarrito => 
      prevCarrito.filter(item => 
        !(item.id === repuestoId && item.esExterno === esExterno)
      )
    );
  };
  
  // Función para actualizar la cantidad de un repuesto en el carrito
  const actualizarCantidad = (repuestoId, esExterno, nuevaCantidad) => {
    if (nuevaCantidad < 1) return;
    
    setCarrito(prevCarrito =>
      prevCarrito.map(item =>
        item.id === repuestoId && item.esExterno === esExterno
          ? { ...item, cantidad: parseInt(nuevaCantidad, 10) }
          : item
      )
    );
  };

  const tabs = [
    {
      id: 'inventario',
      label: 'Inventario',
      icon: <FaBox className="mr-2" />,
      content: <RepuestosExternosInventario 
              onAgregarAlCarrito={agregarAlCarrito} 
              carrito={carrito}
            />
    },
    {
      id: 'seguimiento',
      label: 'Seguimiento de Órdenes',
      icon: <FaTruck className="mr-2" />,
      content: <SeguimientoOrdenesExternas />
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Repuestos Externos</h1>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setShowCarrito(true)}
            className="relative p-2 text-gray-700 hover:text-gray-900 transition-colors"
            aria-label="Ver carrito"
          >
            <FaShoppingCart className="w-6 h-6" />
            {carrito.length > 0 && (
              <Badge 
                className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full"
                size="sm"
              >
                {carrito.reduce((sum, item) => sum + item.cantidad, 0)}
              </Badge>
            )}
          </button>
        </div>
      </div>

      <Tabs>
        {tabs.map(tab => (
          <Tab
            key={tab.id}
            active={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.icon}
            {tab.label}
          </Tab>
        ))}
      </Tabs>

      <div className="bg-white rounded-lg shadow p-6">
        {tabs.find(tab => tab.id === activeTab)?.content}
      </div>

      {/* Carrito de Compras */}
      <CarritoRepuestosExternos 
        isOpen={showCarrito} 
        onClose={() => setShowCarrito(false)}
        onProcederPago={() => {
          setShowCarrito(false);
          setShowPago(true);
        }}
        carrito={carrito}
        onEliminarItem={eliminarDelCarrito}
        onActualizarCantidad={actualizarCantidad}
      />

      {/* Modal de Pago */}
      <PagoRepuestosExternos 
        isOpen={showPago}
        onClose={() => setShowPago(false)}
        datosCarrito={{
          items: carrito,
          total: carrito.reduce((sum, item) => sum + (item.precio * item.cantidad), 0),
          itemsExternos: carrito.filter(item => item.esExterno),
          itemsPropios: carrito.filter(item => !item.esExterno)
        }}
        onPagoCompletado={() => {
          setShowPago(false);
          setActiveTab('seguimiento');
        }}
      />
    </div>
  );
};

export default RepuestosExternosPage;
